"use strict";

define('app/document/decision/document.decision.history.controller',['app/document/decision/document.decision.controller', 'rs/models/document', 'rs/models/document.letter'], function (DocumentDecisionController, Document, DocumentLetter) {
  var DocumentDecisionHistoryController = DocumentDecisionController.extend({
    editable: false,
    start: function start(decisionId) {
      var that = this,
        view = this.getView();
      return Document.requestDecisionById(decisionId).bind(this).then(function (decision) {
        this.setDecision(decision);
        this.setDecisionTypes([]);
        this.setReviewType(decision.getType());
        this.refreshCategoryQuery(decision.getDecisionType());
        this.setStudyDefaultExpirationInterval(0);
        return Promise.join(DocumentLetter.requestAllByDecisionId(decisionId), this.refreshAvailableCategories());
      }).spread(function (documentLetters) {
        this.setLetters(documentLetters);
        this.render();
      });
    }
  });
  return DocumentDecisionHistoryController;
});

